export var RoutesList;
(function (RoutesList) {
    RoutesList["Main"] = "/";
})(RoutesList || (RoutesList = {}));
;
